import { DOWNLOADS } from "../../actions/actionConstants.js";

export const getDownloadPDF = (id, downloadName) => {
  // console.log("getDownloadPDF:", id, downloadName);
  return {
    type: DOWNLOADS.GET_PDF,
    payload: {
      "@id": id,
      downloadName
    }
  };
};

export const getDownloadTXT = (id, downloadName) => {
  // console.log("getDownloadTXT:", id, downloadName);
  return {
    type: DOWNLOADS.GET_TXT,
    payload: {
      "@id": `${id}.txt`, // that's just how the endpoint is named and I have no operation to use
      downloadName
    }
  };
};

export default {};
